// App config — all values come from the env file loaded by the npm script
// (.env.dev for `npm start`, .env.prod for `npm run build`). REACT_APP_* vars
// are baked into the public bundle at build time (so they are NOT secret).
const env = {
  API_URL: process.env.REACT_APP_API_URL || "",
  APP_URL: process.env.REACT_APP_APP_URL || "",
  // The separate public-facing integrations app — linked to, never routed to.
  PUBLIC_APP_URL: process.env.REACT_APP_PUBLIC_APP_URL || "",
  DOCS_URL: process.env.REACT_APP_DOCS_URL || "",
  GHL_MARKETPLACE_URL:
    process.env.REACT_APP_GHL_MARKETPLACE_URL ||
    "https://marketplace.gohighlevel.com",
};

export default env;
